import React,{Component} from "react";
import { FormGroup, Col, Label, Button} from "reactstrap";
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Icon } from 'semantic-ui-react';
import {getSchedulesMailist} from '../../../../action/ReportManagement/ScheduleReport'
import DataExportHeader from "./DataExportHeader";


class EmailRecipients extends Component {
    constructor(props){
        super(props);
        this.state = {
           redirectToList: false,
           IsToAddressError: false,
           IsCcAddressError: false,
           IsFromReportSchedules : false,
           ToMailAddress: "",
           CcMailAddress: "",
           MailSubject: "",
           MailMessage: "",
           reportId: 0,
           EmailTemplateId: 0,
           IsValid : true,
           reportNameValue:''
        }
        this.OnNext = this.OnNext.bind(this);
        this.goBack = this.goBack.bind(this);
        this.OnCancel = this.OnCancel.bind(this);
    }

    componentWillMount() {
      
        //this will set the default session storage for the email.
        sessionStorage.setItem('emailRadioBtnControl', false);

        var IsFromReportSchedules;
        IsFromReportSchedules = sessionStorage.getItem("IsFromReportSchedules");
        if(IsFromReportSchedules !== undefined && IsFromReportSchedules !== null && IsFromReportSchedules === "true"){
            this.setState({IsFromReportSchedules : true});
        }

        var SelectedReportDetails,reportID= 0;
        SelectedReportDetails = sessionStorage.getItem("SelectedReportDetails");
        if(SelectedReportDetails !== undefined && SelectedReportDetails !== null){
           var details = JSON.parse(SelectedReportDetails);
           this.props.getSchedulesMailist(details.id);
           this.setState({
               reportNameValue:details.name
           })
           reportID = details.id;
        }
        
        this.setState({reportId : reportID});
    }

    componentWillReceiveProps(nextProps) {
        if (this.props !== nextProps) {
            if(this.state.IsFromReportSchedules === true 
                || (this.state.reportId > 0)){
                if(this.props.EmailReceipentDetails !== nextProps.EmailReceipentDetails){
                    this.archiveCntrl(nextProps.EmailReceipentDetails.emailRecipients);          
                    this.setState({
                        ToMailAddress: nextProps.EmailReceipentDetails.emailRecipients,
                        CcMailAddress: nextProps.EmailReceipentDetails.ccEmailRecipients,
                        MailSubject: nextProps.EmailReceipentDetails.emailSubject,
                        MailMessage: nextProps.EmailReceipentDetails.emailContents,
                        EmailTemplateId: nextProps.EmailReceipentDetails.emailTemplateId
                      });
                }   
            }          
        }
    }

    OnCancel(){
        this.setState({redirectToList: true});
    }

    getdetails(){
        return  {
            "ReportId": this.state.reportId,
            "EmailTemplates": {     
                "EmailTemplateId": this.state.EmailTemplateId,  
                "EmailTemplateName": "",
                "EmailTemplateDescription": "",                 
                "EmailContent": this.state.MailMessage,
                "EmailSubject": this.state.MailSubject,
                "ReportNameAsSubject": false
            },
            "RecipientEmailAddresses": this.state.ToMailAddress,
            "CCRecipientEmailAddresses": this.state.CcMailAddress,
            "ReportNameAsSubject": false,
            "RecipientEmailIDs": "",
            "CCRecipientEmailIDs": ""
        }
    }

    OnNext(tab) {
        this.setState({ IsToAddressError: false, IsCcAddressError: false, IsValid: true });
        var IsValid = true, IsToError = false, IsCcErorr = false;
        
        let Email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var ToEmailIds = this.refs.input_to_mailAddress.value; 
        var CcEmailIds = this.refs.input_cc_mailAddress.value; 

        if(ToEmailIds !== null && ToEmailIds !== ""){
            var toIds = ToEmailIds.split(';');
            for (let i = 0; i < toIds.length; i++) {
                var toMailId = toIds[i].trim();
                if (toMailId !== "" && !toMailId.match(Email)) {
                    IsValid = false;
                    IsToError = true;
                }
            }
        }

        if(CcEmailIds !== null && CcEmailIds !== ""){
            var ccIds = CcEmailIds.split(';');
            for (let i = 0; i < ccIds.length; i++) {
                var ccMailId = ccIds[i].trim();
                if (ccMailId !== "" && !ccMailId.match(Email)) {
                    IsValid = false;
                    IsCcErorr = true;
                }
            }
        }

        // To Address is mandatory when subject or message or cc address is given
        // if((this.state.MailMessage !== null && this.state.MailMessage !== "") ||  
        //     (CcEmailIds !== null && CcEmailIds !== "")){
        //         if(ToEmailIds === ""){
        //             IsValid = false;
        //             IsToError = true;
        //         }
        // }

        if(this.state.IsFromReportSchedules === false){
            if(IsValid){
                //even though the email is true we want to make sure the string variable is not empty. We will perform this check in the function archiveCntrl()
                this.archiveCntrl(ToEmailIds);          
                this.props.toggle(tab); 
                this.props.setEmailRecipients(ToEmailIds);
                this.props.setEmailDetails(this.getdetails());
            }else{
                this.setState({ IsToAddressError: IsToError, IsCcAddressError: IsCcErorr });
                this.setState({IsValid : false});
            }
        }
        else{
            //move the previous finish functionality to archive - nana.zimmer
            if(IsValid){
                this.archiveCntrl(ToEmailIds);          
                this.props.toggle(tab); 
                this.props.setEmailRecipients(ToEmailIds);
                this.props.setEmailDetails(this.getdetails());      
            }else{
                this.setState({ IsToAddressError: IsToError, IsCcAddressError: IsCcErorr });
                this.setState({IsValid : false});

            }

        }
       
    }

    archiveCntrl(ToEmailIds){
        if (ToEmailIds !== null && ToEmailIds !== "") {
            this.props.setEmailExport(true)
        }else{
            this.props.setEmailExport(false)
        }
    }

    goBack(tab){
        this.setState({ IsToAddressError: false, IsCcAddressError: false, IsValid: true });
        this.props.toggle(tab);
    }

    UpdateToEmail(evt) {    
        this.setState({ ToMailAddress: evt.target.value });
    }

    UpdateCcEmail(evt) {           
        this.setState({ CcMailAddress: evt.target.value });
    }

    UpdateSubject(evt) {
        this.setState({ MailSubject: evt.target.value });
    }

    UpdateMessage(evt) {         
        this.setState({ MailMessage: evt.target.value });
    }

    render(){
        let label = this.props.getLabels;
        let hasFullaccess = this.props.userHasFullaccess;
        hasFullaccess = hasFullaccess !== undefined && hasFullaccess !== null && hasFullaccess ? true : false;

        if(this.state.redirectToList){
           return <Redirect to="/ManageReports/ManageReportsDefinitions"/>         
        }

        return(
            <div id="EmailRecipients">
                   {/*Header Section*/}
                   <FormGroup row>
                   <DataExportHeader isFromReportSchedules={this.state.IsFromReportSchedules} reportNameValue={this.state.reportNameValue} label={label}/>

                </FormGroup>
                   <FormGroup row>
                       <Col sm={{size:12}}>
                            <Label className="dataexportheaderlbl"> Email Recipients </Label>
                       </Col>
                   </FormGroup>
                   <hr/>
                   <FormGroup row style={this.state.IsValid ? { 'display': 'none' } : { 'display': 'block' }} >
                       <Col sm={{size:12}}>
                        <Icon name='exclamation triangle' style={{'color': 'red','padding-right': '20px', 'padding-top': '0px' }} />
                        <Label className="workorderheaderlbl">Error: You left necessary fields blank or entered invalid values.  Review and correct any fields with "!" next to them.</Label>
                       </Col>
                   </FormGroup>
                 
                   <FormGroup row style={{"padding-top":"2px"}}>                  
                       <Col sm={{size:1}}>
                            <button disabled="true" className="EmailButtonStyle">{label['ManageReportSchedule.lblEmailToRecipient.Text'] !== undefined ? label['ManageReportSchedule.lblEmailToRecipient.Text'] : "To:"}</button>
                       </Col>
                       <Col sm={{size:11}} style={{"padding-left":"40px"}}>
                            <input placeholder="No recipents have been specified"
                            disabled={hasFullaccess ? false : true}
                            value= {this.state.ToMailAddress}                           
                            onChange={evt => this.UpdateToEmail(evt)}
                            ref="input_to_mailAddress" className={this.state.IsToAddressError ? "ErrorEmailInputStyle" : "EmailInputStyle"}></input>
                            <span hidden={!this.state.IsToAddressError}><Icon name='exclamation triangle' className="EmailErrorSign" /></span>
                            <label className="EmailLblStyle">Use semi-colons to separate names. Eg: name1@company.com; name2@company.com</label>
                       </Col>
                   </FormGroup>
                   <FormGroup row>
                       <Col sm={{size:1}}>
                            <button disabled="true" className="EmailButtonStyle">{label['ManageReportSchedule.lblEmailCcRecipient.Text'] !== undefined ? label['ManageReportSchedule.lblEmailCcRecipient.Text'] : "Cc:"}</button>
                       </Col>
                       <Col sm={{size:11}} style={{"padding-left":"40px"}}>
                            <input placeholder="No recipents have been specified"
                            disabled={hasFullaccess ? false : true}
                            value={this.state.CcMailAddress}
                            onChange={evt => this.UpdateCcEmail(evt)}
                            ref="input_cc_mailAddress" className={this.state.IsCcAddressError ? "ErrorEmailInputStyle" : "EmailInputStyle"}></input>
                            <span hidden={!this.state.IsCcAddressError}><Icon name='exclamation triangle' className="EmailErrorSign" /></span>
                            <label className="EmailLblStyle">Use semi-colons to separate names. Eg: name1@company.com; name2@company.com</label>
                       </Col>
                   </FormGroup>
                   <FormGroup row>
                       <Col sm={{size:12}}>
                            <Label className="workordermainheaderlbl">{label['ManageReportSchedule.lblEmailSubject.Text'] !== undefined ? label['ManageReportSchedule.lblEmailSubject.Text'] : "Subject"}</Label>
                            <input  disabled={hasFullaccess ? false : true}
                            value={this.state.MailSubject}
                            onChange={evt => this.UpdateSubject(evt)}
                            className="EmailInputStyle" maxLength="1500"></input>
                       </Col>
                   </FormGroup>
                   <FormGroup row>
                       <Col sm={{size:12}}>
                            <Label className="workordermainheaderlbl">{label['ManageReportSchedule.lblEmailMessage.Text'] !== undefined ? label['ManageReportSchedule.lblEmailMessage.Text'] : "Message"}</Label>
                            <textarea rows="5" 
                            disabled={hasFullaccess ? false : true}
                            value={this.state.MailMessage}
                            onChange={evt => this.UpdateMessage(evt)}
                            maxLength="1500" className="EmailTextArea"></textarea>
                       </Col>
                   </FormGroup>
                   
                    {/*Button*/}
                    <FormGroup row className="report_buttons">
                        <Col sm={{ size: 12 }}>
                            <hr/>
                            <Label style={{position:'absolute', marginBottom:'0px', bottom:'0' }} className="link-cursor-underline" onClick={this.OnCancel}>Cancel</Label>
                            <Button style={{float:'right', marginRight:'0px'}} className="btn-success btn-md" onClick={() => { this.OnNext('5'); }}>Next</Button>                          
                            <Button style={{float:'right', marginLeft:'0px'}} className="btn-gray btn-md"  onClick={() => { this.goBack('3'); }}>Back</Button>
                        </Col>
                    </FormGroup>
            </div>
        )
    }
};

const mapStateToProps = state => {
    return {
        getLabels: state.CulturalLabelsRootReducer.ReportMgmt_LabelsBasedOnPreference,
        EmailReceipentDetails: state.ScheduleReportRootReducer.EmailReceipentlist,
        userHasFullaccess: state.authService.HasApplicationFullAcess,
        //selectedReportID: state.ScheduleReportRootReducer.ReportId
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getSchedulesMailist: (report_ID) => dispatch(getSchedulesMailist(report_ID))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmailRecipients);
